import { Key } from "@gravity-ui/icons";
import { Card, Icon } from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";

import { createUserApiToken } from "../../store/fetchers/createUserApiToken";
import css from "./NewApiKeyCard.module.scss";

export const NewApiKeyCard = () => {
  const createToken = useAction(createUserApiToken);
  return (
    <div onClick={createToken}>
      <Card className={css.apiKeyCard} theme="normal" view="outlined" size="m">
        <Icon data={Key} />
        <p>Новый ключ</p>
      </Card>
    </div>
  );
};
